export const useDocumentEditingHistoryRestoreState = (documentId: string) => {
  const isApplyingRestore = useState<boolean>(
    `document-editing-history-restore-${documentId}`,
    () => false
  );

  const beginRestore = () => {
    isApplyingRestore.value = true;
  };

  const endRestore = () => {
    isApplyingRestore.value = false;
  };

  return {
    isApplyingRestore,
    beginRestore,
    endRestore,
  };
};
